import React, { useEffect, useState, type ReactNode } from 'react'
import { NotFound } from '@fs/zion-router'
import getPermission from '@fs/zion-permissions'
import CenteredLoadingSpinner from './CenteredLoadingSpinner'

type Props = {
  children: ReactNode
}

export default function AdminRoute({ children }: Props): JSX.Element | null {
  const [isAdmin, setIsAdmin] = useState(false)
  const [permissionChecked, setPermissionChecked] = useState(false)

  useEffect(() => {
    let isCurrent = true
    getPermission('AdminPermission', 'SubmittedTrees')
      .then(({ authorized }) => {
        if (isCurrent) {
          setIsAdmin(authorized)
          setPermissionChecked(true)
        }
        return undefined
      })
      .catch((e) => {
        console.error(e)
        setPermissionChecked(true)
      })
    return () => {
      isCurrent = false
    }
  }, [])

  if (!permissionChecked) return <CenteredLoadingSpinner />

  if (!isAdmin) return <NotFound />

  return <>{children}</>
}
